import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import PageTitle from 'components/shared/PageTitle';
import BackwardsCompatibleLink from 'components/navigation/BackwardsCompatibleLink';
import { BackIcon } from 'components/templates/shared/styledComponents';

// #region styled-components
const Container = styled.div`
  margin-bottom: var(--cc_size_spacing_s);
`;

const BreadcrumbContainer = styled.div`
  margin-block-start: -16px;
  margin-block-end: 16px;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  border-bottom: ${(props) =>
    props.noBorderBottom
      ? 'none'
      : `var(--cc_size_border_width_s) solid var(--cc_color_border_default)`};

  margin-block-end: var(--cc_size_spacing_l);
  padding-block-end: var(--cc_size_spacing_m);
`;

const HeaderTitle = styled.h1`
  margin: 0;
  font-weight: 800;
`;
// #endregion

const ProjectSubpage = ({
  projectId,
  projectTitle,
  subpageTitle,
  cta,
  children,
  isModal = false,
  noBorderBottom = false,
}) => {
  return (
    <Container>
      {/* if this is within a modal, it therefore isn't a page and thus does not need to update the tab title */}
      {!isModal && <PageTitle title={`${projectTitle} - ${subpageTitle}`} />}
      {!isModal && projectId && projectTitle ? (
        <BreadcrumbContainer>
          <BackwardsCompatibleLink
            variant="breadcrumb"
            icon={{
              name: 'chevron-left',
              position: 'before',
            }}
            to={`/projects/${projectId}`}
            data-testid="project__collaborators__back-to-project-link"
          >
            <BackIcon />
            {projectTitle}
          </BackwardsCompatibleLink>
        </BreadcrumbContainer>
      ) : null}
      {!isModal && (
        <HeaderContainer noBorderBottom={noBorderBottom}>
          <HeaderTitle>{subpageTitle}</HeaderTitle>
          {cta}
        </HeaderContainer>
      )}
      {children}
    </Container>
  );
};

ProjectSubpage.propTypes = {
  projectId: PropTypes.number,
  projectTitle: PropTypes.string,
  subpageTitle: PropTypes.string,
  cta: PropTypes.node,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  isModal: PropTypes.bool,
  noBorderBottom: PropTypes.bool,
};

ProjectSubpage.defaultProps = {
  noBorderBottom: false,
};

export default ProjectSubpage;
